import { ActivityType, ActivityVisibility, ActorType, FeedGroupType } from '@forto-dev/feed-v2-models'

import { ApiConfig, clientFactory, EndpointConfig } from '@/api/clientFactory'
import { User } from '@/features/auth'

import { APIFeed, Feed, FeedSchema } from '../domain/feed'

const shippingBasePath = '/api/shipping'
const basePath = '/api/feed-v2'

export type EntityFeedPageParams = {
  orderByDesc: string
  page: number
  pageSize: number
  entityID: string[]
  activityTypes?: ActivityType[]
}

type CreateFeedActivityParams = {
  entityId: string
  user?: User
  data: {
    content: string
  }
}

export type CreateFeedActivityResult = {
  activitySent: boolean
}

export const activityFeedConfig: ApiConfig<{
  getEntityFeed: EndpointConfig<{ pageParam: EntityFeedPageParams }, APIFeed, Feed>
  createV1ShipmentFeedActivity: EndpointConfig<CreateFeedActivityParams, void>
  createV2ShipmentFeedActivity: EndpointConfig<CreateFeedActivityParams, void>
}> = {
  getEntityFeed: {
    requestConfig: ({ pageParam }) => ({
      endpoint: `${basePath}/feed`,
      method: 'get',
      deserializationStrategy: FeedSchema,
      options: {
        params: Object.fromEntries(Object.entries(pageParam).filter(([, value]) => typeof value !== 'undefined')),
      },
    }),
  },
  createV1ShipmentFeedActivity: {
    requestConfig: ({ entityId, user, data }) => ({
      endpoint: `${shippingBasePath}/activities/reference/${entityId}`,
      method: 'post',
      body: {
        content: data.content,
        type: ActivityType.MessageFeedV1,
        userId: user?._id,
      },
    }),
  },
  createV2ShipmentFeedActivity: {
    requestConfig: ({ entityId, user, data }) => ({
      endpoint: `${basePath}/activities`,
      method: 'post',
      body: {
        activity: {
          actor: {
            type: ActorType.Person,
            id: user?._id,
            fullName: user ? `${user?.firstName} ${user?.lastName}` : undefined,
            email: user?.email,
          },
          type: ActivityType.MessageFeedV1,
          object: {
            id: entityId,
            type: ActivityType.MessageFeedV1,
          },
          customField: {
            feedV1Activity: {
              content: data.content,
              referenceId: entityId,
              userAuthor_id: user?._id,
              type: ActivityType.MessageFeedV1,
            },
          },
        },
        feedInfo: {
          customerID: user?.customer_id,
          entityID: entityId,
          entityType: entityId.startsWith('B') ? 'booking' : 'shipment',
          activityVisibility: ActivityVisibility.public,
          groupType: FeedGroupType.flat,
        },
      },
    }),
  },
}

export const activityFeedClient = clientFactory(activityFeedConfig)
